var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('circle',{staticClass:"fill-current",attrs:{"cx":"12","cy":"12","r":"10"}}),_c('path',{attrs:{"fill":"#FFFFFF","d":"M10 14.59l6.3-6.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.42l2.3 2.3z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }